module.exports = __webpack_public_path__ + "static/img/isp_img_1.abb06cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/isp_img_1.svg
// module id = GDKK
// module chunks = 0